export default {
    isEmpty: (str) => {
        return str == null || str == '' || str.length == 0 || str == undefined;
    }
}